export const GESTAO_AMEI_PROP = '_gestaoAmei';
export const IF_GROUP = 'Instituição Financeira';
export const IF_GESTOR_UF_GROUP = 'Instituição Financeira do Gestor de UF';
export const UF_IF_GROUP = 'UF da Instituição Financeira';
export const UF_GROUP = 'UF';

export const Role = {
  Administrador: 'ROLE_ADMINISTRADOR',
  GestorNacional: 'ROLE_SEBRAE_NA',
  GestorUF: 'ROLE_SEBRAE_UF',
  GestorIF: 'ROLE_IF',
};

export const getRoleByCode = (roleCode) => {
  const roleMap = {
    1: Role.Administrador,
    2: Role.GestorNacional,
    3: Role.GestorIF,
    4: Role.GestorUF,
  };
  return roleMap[roleCode];
};

export const ADMIN_ICON = 'shield-check';
